import { AxiosResponse } from 'axios'
import { ServiceConfig } from 'shared/services/ServiceConfig'

import IOrdemCarregamentoRequest from '../../domain/entities/OrdemCarregamentoRequest'
import { IOrdemCarregamentoRepository } from '../../domain/repositories/IOrdemCarregamentoRepository'

const http = new ServiceConfig()
export default class OrdemCarregamentoRepository
  implements IOrdemCarregamentoRepository
{
  public async findByCodigoOcOuLoteSolicitadoId(
    params: IOrdemCarregamentoRequest,
  ): Promise<string> {
    let url = `/lotes-solicitados/${params.lote_solicitado_id}/ordem-carregamento?type=${params.type}`

    if (params.ordem_carregamento_codigo)
      url =
        url + `&ordem_carregamento_codigo=${params.ordem_carregamento_codigo}`
    const response: AxiosResponse<string> = await http.get(url)
    return response.data
  }
}
